import { Account, Bet, GenericEventWin, GenericState, ReelBoard, SymbolWin } from '@1x2network/is_engine_communication'
import { PositionTuple } from '@1x2network/reel_set'
import { SymbolModel } from './SymbolModel'

/**
 * Typing for the model in the base game
 * @author Jordan Harrison - <jordan.harrison@1x2network.com>
 * @version 1.0.0
 */

export interface BaseToHoldAndWinState extends GenericState {
    holdAndWin: {
        spins: {
            remaining: number
            total: number
        }
    }
    phase: {
        current: 'NORMAL'
        next: 'HOLD_AND_WIN'
    }
}

export interface BaseToBaseState extends GenericState {
    phase: {
        current: 'NORMAL'
        next: 'NORMAL'
    }
}

export type BaseGameToBaseGameModel = GenericSpinResponse<AnticipateResults<never>, BaseToBaseState>
export type BaseGameToHoldAndWinModel = GenericSpinResponse<AnticipateResults<CoinShowerEvent>, BaseToHoldAndWinState>

export type AnyBaseGameModel = BaseGameToBaseGameModel | BaseGameToHoldAndWinModel

export interface CoinShowerEvent extends GenericEventWin {
    type: 'TRANSFORM'
    transforms: { position: PositionTuple; data: SymbolModel }[]
}

export function isBonusTrigger(model: AnyBaseGameModel): model is BaseGameToHoldAndWinModel {
    return model.state.phase.current === 'NORMAL' && model.state.phase.next === 'HOLD_AND_WIN'
}

interface Results<TEvent extends GenericEventWin = GenericEventWin, TBoard extends ReelBoard = ReelBoard> {
    wins: {
        symbol: SymbolWin[]
        events: TEvent[]
    }
    board: TBoard
}

interface AnticipateResults<TEvent extends GenericEventWin> extends Results<TEvent, ReelBoard<SymbolModel>> {
    anticipate: {
        anticipate: Array<number>
    }
}

interface GenericSpinResponse<TResults extends Results = Results, TState extends GenericState = GenericState> {
    bet: Bet
    account: Account
    results: TResults
    state: TState
}
